import React from 'react';
import { Pressable } from 'react-native';
import Unicon from '@/components/General/Unicon';
import { StyleSheet } from 'react-native-unistyles';
import { Tooltip } from '@/components/General/Tooltip';

const IconButton = ({
    iconName,
    iconLibrary = 'ionicon',
    iconSize = 22,
    buttonSize = 36,
    type = 'primary',
    disabled = false,
    onPress,
    tooltipText = '',
    testID = '',
}) => {
    const buttonStyle = styles.button(type, disabled, typeof onPress === 'function', buttonSize);

    if (tooltipText) {
        return (
            <Tooltip
                title={tooltipText}
                onPress={disabled ? null : onPress}
                style={buttonStyle}
                testID={testID || `IconButton-${iconName}`}
            >
                <Unicon
                    name={iconName}
                    library={iconLibrary}
                    size={iconSize}
                    colorVariant={type}
                />
            </Tooltip>
        );
    }

    return (
        <Pressable
            testID={testID || `IconButton-${iconName}`}
            disabled={disabled}
            onPress={onPress}
            style={buttonStyle}
        >
            <Unicon
                name={iconName}
                library={iconLibrary}
                size={iconSize}
                colorVariant={type}
            />
        </Pressable>
    );
};

const styles = StyleSheet.create(({ colors }) => ({
    button: (type, disabled, canPress, buttonSize = 36) => ({
        width: buttonSize,
        height: buttonSize,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        opacity: disabled ? 0.45 : 1,
        pointerEvents: canPress ? 'auto' : 'none',
        _web: {
            transition: 'background-color 0.15s ease, transform 0.15s ease',
            cursor: disabled ? 'not-allowed' : 'pointer',
            userSelect: 'none',
            _hover: disabled
                ? {}
                : {
                    backgroundColor: colors[type + 'Container'],
                    transform: [{ scale: 1.08 }],
                },
            _active: {
                transform: [{ scale: 0.92 }],
            },
        },
    }),
}));

export default React.memo(IconButton);
